import { render, staticRenderFns } from "./Sresult.vue?vue&type=template&id=aeea48c6&scoped=true&"
import script from "./Sresult.vue?vue&type=script&lang=js&"
export * from "./Sresult.vue?vue&type=script&lang=js&"
import style0 from "./Sresult.vue?vue&type=style&index=0&id=aeea48c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeea48c6",
  null
  
)

export default component.exports